import {
  SUBSCRIPTION_MANAGE_ROUTE,
  SUBSCRIPTION_RENEWALS_ROUTE,
  SUBSCRIPTION_UPDATE_ROUTE,
  SUBSCRIPTION_DETAILS_ROUTE,
  SUBS_MANAGE_ADD_CARD_ROUTE,
  SUBS_MANAGE_UPGRADE_ROUTE,
} from 'features/home/components/HomeSubscription/consts'

const forgotPasswordUrl = '/forgot-password'

const ROUTES = {
  auth: {
    login: '/login',
    forgotPassword: `${forgotPasswordUrl}`,
    forgotPasswordInitSuccess: `${forgotPasswordUrl}/init-success`,
    forgotPasswordResetSuccess: `${forgotPasswordUrl}/reset-success`,
    forgotPasswordResetConfirm: `${forgotPasswordUrl}/reset-confirm`,
    forgotPasswordResetError: `${forgotPasswordUrl}/reset-error`,
    twoFa: '/2fa',
    twoFaSuccess: '/2fa/success',
    twoFaError: '/2fa/error',
  },

  homesJobs: (rootDomainId: string | null) => `/${rootDomainId}/jobs`, // SCM home page (kind of) for jobs with homes
  domainPendingJobs: '/:rootDomainId/pending-jobs', // Page for Jobs with no homes
  home: '/home',
  homeStatus: '/:rootDomainId/home/:homeId/status',
  homeConfiguration: '/:rootDomainId/home/:homeId/configuration',
  homeLicensing: '/:rootDomainId/home/:homeId/licensing',
  homeSoftware: '/:rootDomainId/home/:homeId/software',
  homeDevice: '/:rootDomainId/home/:homeId/devices/:id',
  templates: (rootDomainId: string | null) => `/${rootDomainId}/templates`,
  profiles: (rootDomainId: string | null) => `/${rootDomainId}/profiles`,
  licenses: (rootDomainId: string | null) => `/${rootDomainId}/licenses`,
  team: (rootDomainId: string | null) => `/${rootDomainId}/team`,
  audit: (rootDomainId: string | null) => `/${rootDomainId}/audit`,

  breakerPanels: '/:rootDomainId/home/:homeId/breaker-panels',
  breakerPanel: '/:rootDomainId/home/:homeId/breaker-panels/:panelId',
  breaker:
    '/:rootDomainId/home/:homeId/breaker-panels/:panelId/breaker/:breakerId',
  module:
    '/:rootDomainId/home/:homeId/breaker-panels/:panelId/module/:moduleId',

  companies: '/:rootDomainId/companies',

  aboutCompany: (rootDomainId: string | null) =>
    `/${rootDomainId}/about-company`,
  accountProfile: (rootDomainId: string | null) => `/${rootDomainId}/profile`,
  paymentMethods: (rootDomainId: string | null) =>
    `/${rootDomainId}/payment-methods`,
  addPaymentMethod: (rootDomainId: string | null) =>
    `/${rootDomainId}/payment-methods/add`,
  billingHistory: (rootDomainId: string | null) =>
    `/${rootDomainId}/billing-history`,
  company: '/company',

  homeSubscription: {
    root: () => `/:rootDomainId${ROUTES.home}/:homeId/subscriptions`,
    update: () =>
      `${ROUTES.homeSubscription.root()}/${SUBSCRIPTION_UPDATE_ROUTE}`,
    manage: () =>
      `${ROUTES.homeSubscription.root()}/${SUBSCRIPTION_MANAGE_ROUTE}`,
    renewals: () =>
      `${ROUTES.homeSubscription.root()}/${SUBSCRIPTION_RENEWALS_ROUTE}`,
    details: () =>
      `${ROUTES.homeSubscription.root()}/${SUBSCRIPTION_DETAILS_ROUTE}`,
    addCard: () =>
      `${ROUTES.homeSubscription.manage()}/${SUBS_MANAGE_ADD_CARD_ROUTE}`,
    upgrade: () =>
      `${ROUTES.homeSubscription.manage()}/${SUBS_MANAGE_UPGRADE_ROUTE}`,
  },
  networkAi: {
    wizard: {
      rootNoJob: '/:rootDomainId/network-wizard',
      rootNoJobAddNetwork: '/:rootDomainId/network-wizard/add',
      root: '/:rootDomainId/home/:homeId/job/:jobId/network-wizard',
      addNetwork: '/:rootDomainId/home/:homeId/job/:jobId/network-wizard/add',
      purchaseSubscription:
        '/:rootDomainId/home/:homeId/job/:jobId/network-wizard/purchase-subscription',
      claimDevice:
        '/:rootDomainId/home/:homeId/job/:jobId/network-wizard/claim-device',
      devicesList:
        '/:rootDomainId/home/:homeId/job/:jobId/network-wizard/devices-list',
      createWLANs:
        '/:rootDomainId/home/:homeId/job/:jobId/network-wizard/create-wlans',
      createWLANsSetup:
        '/:rootDomainId/home/:homeId/job/:jobId/network-wizard/create-wlans/setup',
      saveTemplate:
        '/:rootDomainId/home/:homeId/job/:jobId/network-wizard/save-template',
      selectTemplate:
        '/:rootDomainId/home/:homeId/job/:jobId/network-wizard/select-template',
      copyHome:
        '/:rootDomainId/home/:homeId/job/:jobId/network-wizard/copy-home',
    },
    dashboard: {
      root: '/:rootDomainId/home/:homeId/network/job/:jobId',
      rootNoJob: '/:rootDomainId/home/:homeId/network/',
      accessPoints:
        '/:rootDomainId/home/:homeId/network/job/:jobId/access-points',
      networkAlerts:
        '/:rootDomainId/home/:homeId/network/job/:jobId/network/alerts',
      networkClients:
        '/:rootDomainId/home/:homeId/network/job/:jobId/network/clients',
      networkWLANs:
        '/:rootDomainId/home/:homeId/network/job/:jobId/network/wlans',
      editCreateWLANs:
        '/:rootDomainId/home/:homeId/network/job/:jobId/network/wlan/:wlanId',
    },
  },
}

export default ROUTES
